import React from "react";

export default function AGB() {
  const currentYear = new Date().getFullYear();

  return (
    <div
      style={{
        padding: "3rem 2rem",
        maxWidth: "900px",
        margin: "0 auto",
        lineHeight: "1.6",
        fontFamily: "'Inter', Arial, sans-serif",
        color: "#222",
      }}
    >
      {/* HEADER */}
      <header style={{ borderBottom: "3px solid #d44", marginBottom: "2rem" }}>
        <div className="pt-6" />
        <h1 style={{ fontSize: "2rem", marginBottom: "0.5rem" }}>
          Allgemeine Geschäftsbedingungen (AGB)
        </h1>
        <p style={{ color: "#666", marginBottom: "1rem" }}>
          für die Nutzung der Website und den Erwerb automatisierter GeoReports
        </p>
      </header>

      {/* --- Geltungsbereich --- */}
      <section style={{ marginBottom: "2rem" }}>
        <h2 style={{ color: "#d44", fontSize: "1.4rem" }}>1. Geltungsbereich</h2>
        <p>
          Diese Allgemeinen Geschäftsbedingungen gelten für die Nutzung dieser
          Website sowie für alle über die Website angebotenen und erworbenen
          automatisierten Standort- und GeoReports (nachfolgend „Reports“).
        </p>
        <p>
          Abweichende Bedingungen der Nutzerinnen und Nutzer finden keine
          Anwendung, sofern ihnen nicht ausdrücklich schriftlich zugestimmt
          wurde.
        </p>
      </section>

      {/* --- Vertragspartner --- */}
      <section style={{ marginBottom: "2rem" }}>
        <h2 style={{ color: "#d44", fontSize: "1.4rem" }}>2. Vertragspartner</h2>
        <p>
          Vertragspartner für alle über diese Website geschlossenen Verträge ist:
        </p>
        <p>
          <strong>Dr.-Ing. Eike Radeisen</strong><br />
          Einzelunternehmen – Erdwärme-Experten
        </p>
      </section>

      {/* --- Leistungsbeschreibung --- */}
      <section style={{ marginBottom: "2rem" }}>
        <h2 style={{ color: "#d44", fontSize: "1.4rem" }}>3. Leistungsbeschreibung</h2>
        <p>
          Gegenstand des Vertrages ist die Bereitstellung automatisiert erzeugter,
          datenbasierter Reports zur standortbezogenen Ersteinschätzung
          geothermischer Potenziale.
        </p>
        <p>
          Die Reports werden ohne individuelle fachliche Prüfung ausschließlich
          algorithmisch auf Basis externer Geodaten, vereinfachter Modelle und
          typischer Annahmen erstellt.
        </p>
      </section>

      {/* --- Keine Fachplanung --- */}
      <section style={{ marginBottom: "2rem" }}>
        <h2 style={{ color: "#d44", fontSize: "1.4rem" }}>
          4. Keine Fachplanung, kein Gutachten
        </h2>
        <p>
          Die Reports stellen ausdrücklich keine Fachplanung, kein Gutachten und
          keine behördlich oder rechtlich verwertbare Entscheidungsgrundlage dar.
        </p>
        <p>
          Insbesondere ersetzen sie keine Planung nach VDI 4640, keine
          Baugrunduntersuchung, keine Genehmigungsprüfung sowie keine individuelle
          Energie-, Förder- oder Rechtsberatung.
        </p>
      </section>

      {/* --- Vertragsschluss --- */}
      <section style={{ marginBottom: "2rem" }}>
        <h2 style={{ color: "#d44", fontSize: "1.4rem" }}>5. Vertragsschluss</h2>
        <p>
          Der Vertrag kommt zustande, indem der Nutzer den Bestellprozess
          abschließt und die Zahlung erfolgreich durchgeführt wird.
        </p>
        <p>
          Vor Abschluss der Bestellung ist die Zustimmung zu diesen AGB sowie zur
          Widerrufsbelehrung erforderlich.
        </p>
      </section>

      {/* --- Preise & Zahlung --- */}
      <section style={{ marginBottom: "2rem" }}>
        <h2 style={{ color: "#d44", fontSize: "1.4rem" }}>6. Preise und Zahlung</h2>
        <p>
          Alle angegebenen Preise verstehen sich als Endpreise. Aufgrund der
          Anwendung der Kleinunternehmerregelung gemäß §19 UStG wird keine
          Umsatzsteuer ausgewiesen.
        </p>
        <p>
          Die Zahlung erfolgt über die im Bestellprozess angebotenen
          Zahlungsdienstleister.
        </p>
      </section>

      {/* --- Lieferung --- */}
      <section style={{ marginBottom: "2rem" }}>
        <h2 style={{ color: "#d44", fontSize: "1.4rem" }}>7. Bereitstellung der Reports</h2>
        <p>
          Die Reports werden nach erfolgreicher Zahlung digital bereitgestellt,
          in der Regel als Download oder per E-Mail.
        </p>
      </section>

      {/* --- Widerruf --- */}
      <section style={{ marginBottom: "2rem" }}>
        <h2 style={{ color: "#d44", fontSize: "1.4rem" }}>8. Widerrufsrecht</h2>
        <p>
          Bei digitalen Inhalten erlischt das Widerrufsrecht, sobald mit der
          Ausführung des Vertrages begonnen wurde, nachdem der Nutzer ausdrücklich
          zugestimmt hat, dass mit der Ausführung vor Ablauf der Widerrufsfrist
          begonnen wird.
        </p>
      </section>

      {/* --- Haftung --- */}
      <section style={{ marginBottom: "2rem" }}>
        <h2 style={{ color: "#d44", fontSize: "1.4rem" }}>9. Haftung</h2>
        <p>
          Es gelten die auf der Website veröffentlichten Haftungs- und
          Nutzungshinweise ergänzend zu diesen AGB.
        </p>
      </section>

      {/* --- Schlussbestimmungen --- */}
      <section style={{ marginBottom: "2rem" }}>
        <h2 style={{ color: "#d44", fontSize: "1.4rem" }}>10. Schlussbestimmungen</h2>
        <p>
          Es gilt das Recht der Bundesrepublik Deutschland. Sollten einzelne
          Bestimmungen dieser AGB unwirksam sein oder werden, bleibt die
          Wirksamkeit der übrigen Bestimmungen unberührt.
        </p>
      </section>

      {/* FOOTER */}
      <footer style={{ borderTop: "1px solid #ddd", paddingTop: "1rem", color: "#555" }}>
        <p>© {currentYear} Dr.-Ing. Eike Radeisen – Erdwärme-Experten</p>
      </footer>
    </div>
  );
}
